import React, { useEffect, useRef } from 'react';
import './ParticleBackground.css';

const ParticleBackground = () => {
  const particlesRef = useRef(null);

  useEffect(() => {
    const container = particlesRef.current;
    if (!container) return;
    for (let i = 0; i < 20; i++) {
      const p = document.createElement('div');
      p.className = 'pb-particle';
      const size = Math.random() * 3 + 1;
      p.style.cssText = `
        width: ${size}px; height: ${size}px;
        left: ${Math.random() * 100}%;
        bottom: -10px;
        --dur: ${Math.random() * 12 + 8}s;
        --delay: -${Math.random() * 10}s;
      `;
      container.appendChild(p);
    }
    return () => { container.innerHTML = ''; };
  }, []);

  return (
    <div className="pb-bg">
      <div className="pb-gradient" />
      <div className="pb-particles" ref={particlesRef} />
      <div className="pb-grain" />
    </div>
  );
};

export default ParticleBackground;
